import { useQuery } from '@tanstack/react-query';

import { useApi } from '@sbv-clients/data-access-api';

import { MetricCacheKeys } from '../utils/cache-keys';

export const useEmployeeMetricGet = (
  facilityId: string | 'All',
  onlyNew?: boolean
) => {
  const sending = facilityId === 'All' ? '' : facilityId;
  const api = useApi();
  return useQuery({
    queryKey: [
      MetricCacheKeys.EMPLOYEE_METRIC,
      { facilityId: sending, onlyNew },
    ],
    queryFn: () =>
      api.metricsApi
        .metricsEmployeesGet({
          facilityId: sending,
          onlyShowNewScheduler: onlyNew,
        })
        .then((response) => response?.data?.data ?? {}),
    retry: false,
    refetchOnWindowFocus: false,
  });
};

export type EmployeeMetricResponseType = NonNullable<
  ReturnType<typeof useEmployeeMetricGet>['data']
>;

export const useAdminApiMetricGet = (facilityId: string | null) => {
  const api = useApi();
  return useQuery({
    queryKey: [MetricCacheKeys.ADMIN_API_METRIC, { facilityId }],
    queryFn: () =>
      api.metricsApi
        .metricsRequestCountPost({
          metricsRequest: {
            durationInDays: 100,
            facilityId,
          },
        })
        .then((response) => response?.data ?? []),
    retry: false,
    refetchOnWindowFocus: false,
  });
};
